'use strict';

var novicell = novicell || {}; // eslint-disable-line

// novicell.navigationMessage = novicell.navigationMessage || new function () {
//     this.init = function () {
//         var a = document.querySelector("a.PostLogoutRedirectUri");
//         if (a) {
//             window.location = a.href;
//         }
//     };
// }();